import Dispatcher from "../../dispatcher";

export const LandingActionTypes = {
  LandingPageLoaded: 'LANDING_PAGE_LOADED',
};

export function LandingPageLoaded() {
  Dispatcher.dispatch({
    type: LandingActionTypes.LandingPageLoaded,
  });
}